<template>
  <div class="row">
    <div id="contentTop" />
    <div class="col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">Page does not exist!</h3>
          <p class="category">(404 Not Found)</p>
        </div>
        <div class="card-content">
          <p>Oops! It seems that this page does not exist or cannot be found.</p>
          <p>If you continue to recieve this error, please contact us below.</p>
          <p>Otherwise, please return <router-link :to="{path:'/'}">home</router-link></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {}

</script>
